import { axios } from '@/plugins/axios';

export const getPartner = () => axios.get(`/partners`).then(res => res.data);
